import { useContext, useEffect } from 'react';
import { AzureMapsContext } from 'react-azure-maps';
import busRedWhite from '../../../static/bus-icon-red-white.png';
import busRed from '../../../static/bus-icon-red.png';
import busBlue from '../../../static/bus-icon.png';
import busStopSelectedIcon from '../../../static/bus-stop-20-hover.png';
import busStopIcon from '../../../static/bus-stop-20.png';

export const AzureMapSpriteRegistrar = () => {
    const {
        mapRef,
        isMapReady,
    } = useContext(AzureMapsContext);

    const buspushpin = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuNWWFMmUAAAIoSURBVEhLrZbBS1VBFMZd5S6IFi5yZ1hiuREjxV1UgkSEhIVEQRERtXApbVu0yX0tcuFCfLtA+geiVrZLBNsltHfpptvvm9s85557xvdG/OAHM3NmzvfumTtz30BVVf0wDavQgX2IUltjimmOt7aBO5hwH1KDXtJcrfFyBdxBGIbvcFJprXK0crcGoPSpcnKfttEBTfC0B2vwCu7BDFz7334NH+EXeGqYpmYqgX2yXZgHxS/CDbgLCwaZa84s/IRUytktbzQTds/+wgjE+EP4kOEFxHlKfgiplDvE4ySvlH9AsTFQ3PIMnic8hUnQmh2w0pquofeSfAXFfoRef/oNWvM59JqSRzDUgfX0CRQ/CL3+dRbe182WppVQt4SnN3C+bhZpCl7WzZZWZairydMSXK+bRXoAc3WzpY4Mvf2TdNYW62aRVuBy3WxpX4Y5TYDOlSpQwi24AK6OM7wKip+EYw1zJb0CNlG/5AxDSVUGT+NwBh7BENiklnPwGAYhZxhemtyx0A3zpG5W62ANLPHsLUPOMByL3MHXmzYKW3AHrIHlNnwDbUXOMBx84e3jJUgTluAZdq82oYvV6rQNG5e3sJ+nTbgJiumT864H8Qfq26g9T9X6PMWktrRvQTEd5l7SVai59h5VTvcDLGxpt0EvTu5NTrUBmvsl9I4UShlJzSKakLsMSqQcDTPR6CSoBHZPS6S13TKmtAYMpU/rPlWKO+hwSn/1q4F/eQ3bgDdUGc4AAAAASUVORK5CYII=';

    useEffect(() => {
        if (!isMapReady || !mapRef) return;
        const map = mapRef;
        // Пример регистрации иконки
        map.imageSprite.add('stopIcon', busStopIcon)
            .then(() => {
                console.log('✅ Sprite registered');
            }).catch((err) => {
            console.error('❌ Failed to register sprite', err);
        });
        map.imageSprite.add('stopSelectedIcon', busStopSelectedIcon)
            .then(() => {
                console.log('✅ Sprite registered');
            }).catch((err) => {
            console.error('❌ Failed to register sprite', err);
        });
        map.imageSprite.add('busBlue', busBlue)
            .then(() => {
                console.log('✅ Sprite registered');
            }).catch((err) => {
            console.error('❌ Failed to register sprite', err);
        });
        map.imageSprite.add('busRed', busRed)
            .then(() => {
                console.log('✅ Sprite registered');
            }).catch((err) => {
            console.error('❌ Failed to register sprite', err);
        });
        map.imageSprite.add('busRedWhite', busRedWhite).then(() => {
                    console.log('✅ Sprite with white background registered');
                }).catch((err) => {
                    console.error('❌ Failed to register sprite with white background', err);
                });
        map.imageSprite.add('bus-pushpin', buspushpin)
            .then(() => {
                console.log('✅ Sprite registered');
            }).catch((err) => {
            console.error('❌ Failed to register sprite', err);
        });
    }, [isMapReady]);

    return null;
};
